// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetRedebitByIdRequestModel from '../../model/get-redebit-by-id-request-model';
import GetRedebitByIdRequestDTO from '../dto/get-redebit-by-id-request-dto';
import dtoSchema from '../schemas/get-redebit-by-id-request-schema';

export default abstract class GetRedebitByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetRedebitByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetRedebitByIdRequestDTO>): GetRedebitByIdRequestModel;
  static toModel(dto: DeepPartial<GetRedebitByIdRequestDTO> | undefined | null): GetRedebitByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetRedebitByIdRequestDTO> | undefined | null): GetRedebitByIdRequestModel | undefined {
    return dto ? new GetRedebitByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetRedebitByIdRequestModel> | GetRedebitByIdRequestModel): GetRedebitByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetRedebitByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetRedebitByIdRequestModel, can not map to GetRedebitByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
